import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { environment } from '../../../../../../../../environments/environment';
import { UserService } from '../../../../../../services/users/user.service';
import { fuseAnimations } from '../../../../../../../core/animations';
import { Role } from '../../../../../../models/roles/role';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { RoleService } from '../../../../../../services/roles/role.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { ImageService } from '../../../../../../services/images/image.service';
import { CustomValidators } from '../../../../../../helpers/custom-validators.helper';
import {Observable} from 'rxjs/Observable';
import {ShiftService} from '../../../../../../services/shifts/shift.service';
import {Shift} from '../../../../../../models/shifts/shift';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const PASSWORD_REGEX = /^(?=.*[a-zñ])(?=.*[A-ZÑ])(?=.*\d)(?=.*[$@$#%_-])([A-ZÑa-zñ\d$@$#%_-]|[^'\"°|¬!&/()=?¡¿¨*+~{}`^\[\] ]){6,20}$/;

@Component({
    selector: 'fuse-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.scss'],
    animations: fuseAnimations
})
export class FuseAddUserComponent implements OnInit, AfterViewInit {

    @BlockUI('ea-photo-profile') blockUI: NgBlockUI;

    emailFormControl;
    password;
    confirmPassword;
    firstNameFormControl;
    lastNameFormControl;
    applicationRoleFormControl;

    userFormGroup;

    roles: Role[];
    shifts: Shift[] = [];
    baseUri;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<FuseAddUserComponent>,
        private userService: UserService,
        private translationService: TranslationService,
        private roleService: RoleService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        private imageService: ImageService,
        public shiftService: ShiftService
    ) {
        console.log('FuseAddUserComponent > data', data);
        this.roles = [];
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri;
    }

    ngOnInit() {
        Observable.combineLatest(
            this.roleService.getAll(),
            this.shiftService.getAll()
        ).subscribe(([ roles, shifts]) => {
            this.roles = roles;
            shifts.forEach(s => {
                s.Checked = false;
            });
            this.shifts = shifts;
        });
    }

    ngAfterViewInit() {

    }

    initializeFormControlValidators() {
        this.userFormGroup = this.fb.group({
            emailFormControl: ['', [Validators.required]],
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
            firstNameFormControl: ['', [Validators.required]],
            lastNameFormControl: ['', [Validators.required]],
            applicationRoleFormControl: ['', [Validators.required]],
        }, {
            validator: CustomValidators.passwordsMatch // your validation method
        });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        console.log('FuseAddUserComponent > save', this.data.user);
        this.data.user.Roles[0] = this.roles.find(ar => ar.Id === this.data.user.Roles[0].Id);
        this.data.user.Shifts = this.shifts.filter(e => e.Checked).map(e => {
            return {Id: e.Id};
        });
        this.userService.add(
            this.data.user.Id,
            this.data.user.UserName,
            this.data.user.Password,
            this.data.user.ConfirmPassword,
            this.data.user.FirstName,
            this.data.user.LastName,
            this.data.user.PhoneNumber,
            this.data.user.DocumentNumber,
            this.data.user.Roles[0].Id,
            this.data.user.Photo,
            this.data.user.Shifts).subscribe(response => {
            if (response.ResultCode == 1) {
                // this.data.user.Id = response.UserId;
                this.dialogRef.close(this.data.user);
                this.translationService.translate('LABELS.CORRECTLY_ADDED', this.translationService.user, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                })
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                })
            }
        }, error => {
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            })
        });
    }

    uploadPhoto(event: any) {
        console.log('FuseAddUserComponent > uploadPhoto > event', event);
        const file = event.target.files[0];
        const maxFileSize = 1 * 1024 * 1024; // 1Mb
        console.log('FuseAddUserComponent > uploadPhoto > maxFileSize', maxFileSize);
        console.log('FuseAddUserComponent > uploadPhoto > file.zize', file.size);
        if (file.size > maxFileSize) {
            this.translationService.translate('ERRORS.MAXIMUM_SIZE_EXCEEDED', '1Mb', (res) => {
                this.sweetAlertService.error(this.translationService.success, res, null);
            })
            return;
        }
        this.blockUI.start();
        this.imageService.upload(file, this.data.user.Id, 'profile').subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode == 1) {
                this.data.user.Photo = response.FileUri;
                this.data.user.UpdatedDate = new Date(Date.now());
                this.translationService.translate('LABELS.CORRECTLY_UPLOADED_FEMALE', this.translationService.photo, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                })
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                })
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            })
        });
    }


    shiftRequired() {
        return this.shifts.filter(e => e.Checked).length === 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/users/components/add-user/add-user.component.ts